import React, { useState, useReducer, useMemo } from 'react'
import { flatMap, filter, map, some, every, isEmpty, compact, findIndex, uniq, includes } from 'lodash'

import Table from 'UI/Table'
import Filters from 'Features/Filters'
import BooleanIcon from 'UI/BooleanIcon'

import { arrayToOptions } from "Utilities/selectOptions";

import ActionsCell from './Actions'

const filterData = ({ vms, filters }) => filter(vms, (vm) => {
  const filterResults = {}

  if (filters.complianceStatus != 'All') {
    filterResults['complianceStatus'] = some(vm.audit_result, ['passed', filters.complianceStatus])
  }

  if (filters.complianceReasons != 'All') {
    some(
      map(filter(vm.audit_result, ['passed', false]), 'name'),
      name => includes(map(filters.complianceReasons, 'value'), name)
    )
  }

  return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
})

const defaultFilters = {
  complianceStatus: false,
  complianceReasons: 'All'
}

const NonComplianceCell = ({ auditResult }) => (
  <ul>
    {map(filter(auditResult, ['passed', false]), nonCompliance => <li>{nonCompliance.reason_for_noncompliance}</li>)}
  </ul>
)

const complianceResults = (asset, passed) => filter(asset.audit_result, ['passed', passed])
const complianceReasonOptions = vms => arrayToOptions(
  uniq(flatMap(vms, vm => map(complianceResults(vm, false), 'name')))
)

const CloudCoreComplianceReport = ({ data }) => {
  const [filters, changeFilters] = useState(defaultFilters)
  const [vms, setVMs] = useState(data.vms)
  const [, forceUpdate] = useReducer(x => x + 1, 0)
  const options = useMemo(() => ({
    complianceStatus: [{ value: 'All', label: 'All' }, { value: true, label: 'Compliant' }, { value: false, label: 'Non-Compliant' }],
    complianceReasons: complianceReasonOptions(vms)
  }), [vms])

  const updateVMs = (vm) => {
    const vmToUpdateIndex = findIndex(vms, ['id', vm.id])
    vms[vmToUpdateIndex] = vm

    setVMs(vms)
    forceUpdate()
  }

  return (
    <div>
      <Filters {...{ filters, onChange: changeFilters, options, defaultFilters }}>
        <Filters.Select label='Status' filterName='complianceStatus' isMulti={false} />
        {/* <Filters.Select label='Non-compliance Reason' filterName='complianceReasons' isMulti /> */}
      </Filters>
     <Table
        data={filterData({ vms, filters })}
        filterable
        columns={compact([
          { Header: 'VM', accessor: 'name' },
          { Header: 'Resource pool', accessor: 'resource_pool_name' },
          { Header: 'VDC', accessor: 'vdc_name' },
          (filters.complianceStatus === 'All' && {
            Header: 'Compliant',
            id: 'compliant',
            accessor: (asset) => isEmpty(filter(asset.audit_result, ['passed', false])),
            Cell: row => <BooleanIcon {...{ booleanValue: row.value }} />
          }),
          (filters.complianceStatus != true && {
            Header: 'Reason for Non-Compliance',
            id: 'audit_results',
            accessor: asset => complianceResults(asset, true).length,
            Cell: (row) => NonComplianceCell({ auditResult: row.original.audit_result }),
          }),
          {
            Header: 'Actions',
            id: 'actions',
            filterable: false,
            accessor: asset => complianceResults(asset, true).length,
            Cell: (row) => ActionsCell({ vm: row.original, updateVMs, context: { customerOptions: data.customerOptions } })
          }
        ])}
     />
    </div>
  )
}

export default CloudCoreComplianceReport
